import { render, staticRenderFns } from "./Category-Details.vue?vue&type=template&id=42fe9e28"
import script from "./Category-Details.vue?vue&type=script&lang=js"
export * from "./Category-Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports